export type UILoadingPropsType = {
  loading?: boolean | null;
};

export enum ColorType {
  Primary = "primary",
  Secondary = "secondary",
  Inherit = "inherit",
  Success = "success",
  Error = "error",
  Info = "info",
  Warning = "warning",
  Default = "default",
}

export enum TextColorType {
  Primary = "text.primary",
  Secondary = "text.secondary",
}

export enum UIComponentSize {
  Small = "small",
  Medium = "medium",
  Large = "large",
}

export enum ButtonStyleType {
  Text = "text",
  Contained = "contained",
  Outlined = "outlined",
}

export enum ButtonType {
  Button = "button",
  Submit = "submit",
  Reset = "reset",
}

export enum ButtonIconLoadingPosition {
  Start = "start",
  End = "end",
}

export enum ConfirmLabelType {
  Confirm = "Confirm",
  Save = "Save",
  Submit = "Submit",
  Delete = "Delete",
  Remove = "Remove",
  Yes = "Yes",
  Continue = "Continue",
  Apply = "Apply",
  SaveAnyway = "Save anyway",
}

export enum CancelLabelType {
  Cancel = "Cancel",
  Close = "Close",
  No = "No",
  Back = "Back",
  Dismiss = "Dismiss",
}

export type ChipSize = UIComponentSize.Small | UIComponentSize.Medium;
